import type { UISchemaElement } from '@jsonforms/core'

export const stickySorter = (a: UISchemaElement, b: UISchemaElement) =>
  a.options?.stickyOnMobileIndex > b.options?.stickyOnMobileIndex
    ? 1
    : a.options?.stickyOnMobileIndex < b.options?.stickyOnMobileIndex
      ? -1
      : 0

export function getStickyItems(elements: UISchemaElement[]) {
  const arr: UISchemaElement[] = []

  elements.map((e) => {
    if (e.options && e.options.stickyOnMobile) {
      arr.push(e)
    }
  })

  return arr
}
